// extracted by mini-css-extract-plugin
export default {"outer":"ED9upopI8396h8Y7E7Xa","inner":"LVwOSzcI5rTxxOSfO5cq","shift":"zU3tRP4Beky5OIJK3LxB","style-staggered":"IRJ1S99ZJlZYyxNdMeu8"};